var mcLegacyWarrantyAccent = document.currentScript.dataset.accentColor;

function updateCart() {
  if (document.querySelector('[data-mc-cart-root]')) return;
  let totalCartValue = 0;
  let totalWarrantyValue = 0;
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const tagPromises = cart.items.map((item) => {
        const productHandle = item.handle;
        return fetch(`/products/${productHandle}.json`)
          .then((response) => response.json())
          .then((productData) => {
            const productTags = productData.product.tags;

            if (!productTags.includes('no-warranty') && !productTags.includes('warranty-item')) {
              totalCartValue += item.line_price;
            }

            if (productTags.includes('warranty-item')) {
              totalWarrantyValue += item.line_price;
            }
          });
      });

      Promise.all(tagPromises)
        .then(() => {
          const warrantyBrackets = [
            {
              max: 3000000,
              min: 2000000,
              id: '8383087018153',
              handle: 'guardsman-gold-prime-plus-20-001-30-000',
              variantId: '45203599556777',
              price: 899,
            },
            {
              max: 2000000,
              min: 1500000,
              id: '8383086887081',
              handle: 'guardsman-gold-prime-plus-15-001-20-000',
              variantId: '45203599294633',
              price: 849,
            },
            {
              max: 1500000,
              min: 1000000,
              id: '8383086657705',
              handle: 'guardsman-gold-prime-plus-10-001-15-000',
              variantId: '45203598180521',
              price: 749,
            },
            {
              max: 1000000,
              min: 750000,
              id: '8383086428329',
              handle: 'guardsman-gold-prime-plus-7501-10000',
              variantId: '45203597164713',
              price: 649,
            },
            {
              max: 750000,
              min: 500000,
              id: '8383086231721',
              handle: 'guardsman-gold-prime-plus-5001-7500',
              variantId: '45203595231401',
              price: 549,
            },
            {
              max: 500000,
              min: 250000,
              id: '8383086100649',
              handle: 'guardsman-gold-prime-plus-2501-5000',
              variantId: '45203594870953',
              price: 449,
            },
            {
              max: 250000,
              min: 100000,
              id: '8383085969577',
              handle: 'guardsman-gold-prime-plus-1001-2500',
              variantId: '45203594739881',
              price: 349,
            },
            {
              max: 100000,
              min: 0,
              id: '8383084495017',
              handle: 'guardsman-gold-prime-plus-0-1000',
              variantId: '45203584286889',
              price: 199,
            },
          ];

          let warrantiesToApply = {};

          while (totalCartValue > 0) {
            let selectedWarranty = null;

            for (let i = 0; i < warrantyBrackets.length; i++) {
              if (warrantyBrackets[i].max == 3000000 && totalCartValue > warrantyBrackets[i].max) {
                selectedWarranty = warrantyBrackets[i];
                break;
              } else if (
                totalCartValue <= warrantyBrackets[i].max &&
                totalCartValue > warrantyBrackets[i].min
              ) {
                selectedWarranty = warrantyBrackets[i];
                break;
              }
            }

            if (selectedWarranty) {
              let warrantyHandle = selectedWarranty.handle;
              warrantiesToApply[warrantyHandle] = (warrantiesToApply[warrantyHandle] || 0) + 1;
              totalCartValue -= selectedWarranty.max;
            } else {
              break;
            }
          }

          fetchWarrantyPrices(warrantiesToApply)
            .then((warrantyProducts) => {
              if (warrantyProducts.cost == totalWarrantyValue) {
              } else {
                if (totalWarrantyValue) {
                  removeWarrantyProductsAjax()
                    .then((deleted) => {
                      if (deleted) {
                        if (window.location.pathname === '/cart') {
                          window.location.reload();
                          return;
                        }
                      }
                    })
                    .catch((error) => {});
                }

                let warrantyContainer = document.getElementById('warranty-offer');

                if (warrantyProducts.products.length === 0 || !warrantyContainer) return;
                warrantyContainer.innerHTML = '';

                let warrantyBox = document.createElement('div');
                warrantyBox.style.backgroundColor = '#F8F9FA';
                warrantyBox.style.border = '2px solid ' + mcLegacyWarrantyAccent;
                warrantyBox.style.padding = '15px';
                warrantyBox.style.margin = '10px 0';
                warrantyBox.style.borderRadius = '8px';
                warrantyBox.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.1)';
                warrantyBox.style.fontFamily = 'Arial, sans-serif';

                let mainHeading = document.createElement('p');
                mainHeading.style.fontSize = '16px';
                mainHeading.style.fontWeight = 'bold';
                mainHeading.style.marginBottom = '10px';
                mainHeading.innerHTML = `Would you like to protect your purchase against accidental stains and damage for <strong>$${(
                  warrantyProducts.cost / 100
                ).toFixed(2)}</strong>?`;
                warrantyBox.appendChild(mainHeading);

                let warrantyList = document.createElement('ul');
                warrantyList.style.paddingLeft = '20px';
                warrantyList.style.margin = '0';
                warrantyList.style.listStyle = 'disc';

                warrantyProducts.products.forEach((warranty) => {
                  let warrantyItem = document.createElement('li');
                  warrantyItem.style.fontSize = '14px';
                  warrantyItem.style.color = '#555';
                  warrantyItem.innerHTML = `Add <strong>${warranty.quantity}x ${
                    warranty.title
                  }</strong> for <strong>$${(warranty.price / 100).toFixed(2)}</strong>`;
                  warrantyList.appendChild(warrantyItem);
                });

                warrantyBox.appendChild(warrantyList);

                let warrantyInfo = document.createElement('span');
                warrantyInfo.style.marginTop = '10px';

                warrantyInfo.style.display = 'block';

                warrantyInfo.style.cursor = 'pointer';
                warrantyInfo.innerHTML = `<a target="_blank" href="/pages/guardsman-warranty-claims" style="text-decoration: underline;"><i>Learn more about furniture protection plans
         <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" style="margin-bottom: -2px">
            <g id="Interface / External_Link">
                <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
        </svg>
        </i></a>`;
                warrantyBox.appendChild(warrantyInfo);

                if (!document.getElementById('spinner-styles')) {
                  let style = document.createElement('style');
                  style.id = 'spinner-styles';
                  style.innerHTML = `
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
              svg {
                transform-box: fill-box;
                transform-origin: center;
              }
            `;
                  document.head.appendChild(style);
                }

                let addButton = createButtonWithSpinner('Add Warranty', mcLegacyWarrantyAccent);
                addButton.addEventListener('click', function (e) {
                  const button = e.target.closest('button');
                  addWarrantiesToCart(button, warrantyProducts.products);
                });

                warrantyBox.appendChild(addButton);
                warrantyContainer.appendChild(warrantyBox);
              }
            })
            .catch((error) => {
              console.error('Error fetching warranty products:', error);
            });
        })
        .catch((error) => {
          console.error('Error fetching product details:', error);
        });
    })
    .catch((error) => {
      console.error('Error fetching the updated cart:', error);
    });
}

async function fetchWarrantyPrices(warrantiesToApply) {
  let warranty = { products: [], cost: 0 };

  let fetchPromises = Object.keys(warrantiesToApply).map(async (warrantyHandle) => {
    let quantity = warrantiesToApply[warrantyHandle];

    try {
      let response = await fetch(`/products/${warrantyHandle}.js`);
      if (!response.ok) throw new Error(`Failed to fetch ${warrantyHandle}`);

      let product = await response.json();
      let warrantyPrice = product.variants[0].price;

      warranty.products.push({
        title: product.title,
        price: warrantyPrice * quantity,
        variant_id: product.variants[0].id,
        quantity: quantity,
      });

      warranty.cost += warrantyPrice * quantity;
    } catch (error) {
      console.error(`Error fetching ${warrantyHandle}:`, error);
    }
  });

  await Promise.all(fetchPromises);

  return warranty;
}

async function addWarrantiesToCart(button, products) {
  let items = products.map((product) => ({
    id: product.variant_id,
    quantity: product.quantity,
  }));
  try {
    let textSpan = button.querySelector('span:first-child');
    let spinnerSpan = button.querySelector('span:last-child');

    button.disabled = 'disabled';
    textSpan.style.display = 'none';
    spinnerSpan.style.display = 'block';

    let response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    });

    let data = await response.json();
    console.log('Added to cart:', data);
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      button.disabled = false;
      textSpan.style.display = 'block';
      spinnerSpan.style.display = 'none';
    }
  } catch (error) {
    button.disabled = false;
    textSpan.style.display = 'block';
    spinnerSpan.style.display = 'none';
    console.error('Error adding warranties:', error);
  }
}

document.querySelectorAll('.warranty-item-remove').forEach((button) => {
  button.addEventListener('click', async function (event) {
    event.preventDefault();

    let updates = {};

    document.querySelectorAll('.warranty-item-remove').forEach((item) => {
      let itemId = item.getAttribute('data-id');
      if (itemId) updates[itemId] = 0;
    });

    console.log(updates);

    if (Object.keys(updates).length === 0) {
      console.warn('No warranty items found to remove.');
      return;
    }

    console.log('Removing all warranty items:', updates);

    try {
      let response = await fetch(`/cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });

      let data = await response.json();
      console.log('Updated cart:', data);

      window.location.reload();
    } catch (error) {
      console.error('Error removing warranty items:', error);
    }
  });
});

async function removeWarrantyProducts() {
  let deleted = false;
  let updates = {};

  let items = document.querySelectorAll('.warranty-item-remove');

  if (items.length === 0) {
    console.warn('No warranty items found to remove.');
    return false;
  }

  items.forEach((item) => {
    let itemId = item.getAttribute('data-id');
    if (itemId) {
      updates[itemId] = 0;
    }
  });

  console.log('delete items', updates);

  try {
    let response = await fetch(`/cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    let data = await response.json();
    console.log('Updated cart:', data);

    deleted = true;
  } catch (error) {
    console.error('Error removing warranty items:', error);
  }
  return deleted;
}

async function removeWarrantyProductsAjax() {
  let deleted = false;
  let updates = {};

  try {
    let response = await fetch('/cart.js');
    let cart = await response.json();

    if (cart.items.length === 0) {
      console.warn('No items found in the cart.');
      return false;
    }

    cart.items.forEach((item) => {
      if (item.product_type === 'warranty_item') {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) {
      console.warn('No warranty items found to remove.');
      return false;
    }

    console.log('Deleting warranty items:', updates);

    response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    let data = await response.json();
    console.log('Updated cart:', data);

    deleted = true;
  } catch (error) {
    console.error('Error removing warranty items:', error);
  }

  return deleted;
}

function createButtonWithSpinner(text, color) {
  let button = document.createElement('button');
  button.classList.add('custom-add-warranty-button');
  button.style.backgroundColor = color;
  button.style.color = '#FFF';
  button.style.padding = '10px 20px';
  button.style.border = 'none';
  button.style.borderRadius = '5px';
  button.style.cursor = 'pointer';

  button.style.marginTop = '10px';
  button.style.minWidth = '120px';
  button.style.display = 'flex';
  button.style.alignItems = 'center';
  button.style.justifyContent = 'center';
  button.style.gap = '8px';
  button.type = 'button';

  let textSpan = document.createElement('span');
  textSpan.innerText = text;

  let spinnerSpan = document.createElement('span');
  spinnerSpan.style.display = 'none';

  let spinner = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  spinner.setAttribute('width', '20');
  spinner.setAttribute('height', '20');
  spinner.setAttribute('viewBox', '0 0 50 50');
  spinner.style.animation = 'spin 1s linear infinite';

  let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle.setAttribute('cx', '25');
  circle.setAttribute('cy', '25');
  circle.setAttribute('r', '20');
  circle.setAttribute('stroke-width', '5');
  circle.setAttribute('stroke', '#fff');
  circle.setAttribute('fill', 'none');
  circle.setAttribute('stroke-linecap', 'round');

  circle.setAttribute('stroke-dasharray', '90 30');
  circle.setAttribute('stroke-dashoffset', '0');

  spinner.appendChild(circle);
  spinnerSpan.appendChild(spinner);

  button.appendChild(textSpan);
  button.appendChild(spinnerSpan);

  return button;
}
